import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const MagicWand = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path d="M11.75 2.75V1.5H13.25V2.75H14.5V4.25H13.25V5.5H11.75V4.25H10.5V2.75H11.75Z" fill="currentColor" />
    <path
      clipRule="evenodd"
      d="M7.43937 5.56068L1.49403 11.506C0.908241 12.0918 0.908241 13.0416 1.49403 13.6273L2.30604 14.4394C2.89183 15.0251 3.84157 15.0251 4.42736 14.4394L10.3727 8.49401C10.9585 7.90823 10.9585 6.95848 10.3727 6.37269L9.56069 5.56068C8.97491 4.97489 8.02516 4.97489 7.43937 5.56068ZM7.59102 7.53036L8.50003 6.62134L9.31205 7.43335L8.40303 8.34237L7.59102 7.53036ZM6.53036 8.59102L2.55469 12.5667L3.3667 13.3787L7.34237 9.40303L6.53036 8.59102Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path d="M11.75 9V10.25H10.5V11.75H11.75V13H13.25V11.75H14.5V10.25H13.25V9H11.75Z" fill="currentColor" />
    <path d="M4.25 2.75V1.5H5.75V2.75H7V4.25H5.75V5.5H4.25V4.25H3L3 2.75H4.25Z" fill="currentColor" />
  </Icon>
));

export default MagicWand;
